import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { FenceService } from '../../../../services/configurators-2d/applications/fence.service';
import { PostType } from '../../../../models/configurators-2d/applications/fence/post-type';
import { Configuration } from '../../../../models/configurators-2d/applications/fence/configuration';
import { from, Observable, tap } from 'rxjs';
import { distinct } from '../../../../services/helpers/utils';

@Injectable({
  providedIn: 'root',
})
export class PostTypeStateService {
  /**
   * Liste des types de poteau
   */
  postTypes: WritableSignal<PostType[]> = signal([]);

  /**
   * Indique si le service est entrain de faire des changements
   */
  loading: WritableSignal<boolean> = signal(false);

  private readonly fenceService = inject(FenceService);

  /**
   * Requête l'API et défini les types de poteau disponibles
   * @param configuration
   */
  setList(configuration: Configuration): Observable<PostType[]> {
    this.loading.set(true);

    const heights = distinct(configuration.sides.map(s => s.sections.map(sec => sec.height)).flat()) as number[];
    const hasNonRightAngle = configuration.sides.every(s => s.sections.every(sec => sec.hasNonRightAngle));
    const hasAgainstWall = configuration.sides.some(s => s.sections.some(sec => sec.wallStart || sec.wallEnd));
    const hasDoor = configuration.sides.some(s => s.sections.some(sec => sec.hasDoor));

    return from(
      this.fenceService.getPostTypes(
        heights,
        configuration.configurationInstallations.map(i => i.configurationBoards.map(b => b.boardId)).flat(),
        configuration.location.id,
        configuration.wallHeight,
        hasNonRightAngle,
        hasAgainstWall,
        hasDoor,
        configuration.postType?.id
      )
    ).pipe(
      tap((res: PostType[]) => {
        this.postTypes.set(res);
      })
    );
  }
}
